import lodashKebabCase from "lodash/kebabCase";
import moment from "moment-timezone";

import CONSTANTS from "../Constants.js";
export const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Safely access nested properties
export const getProperty = (obj, props) => {
  let result = obj;
  const lookupFn = (objFragment, prop) =>
    objFragment ? objFragment[prop] : null;
  const lookups = props.split(".");
  while (lookups.length && result !== null) {
    result = lookupFn(result, lookups[0]);
    lookups.shift();
  }
  return result;
};

// Set current timezone to the tenant and re-export the moment global object to fix older scripts
// NOTE: Setting moment back to the window object is very important until we remove our older scripts
export const currentTenantTimezone =
  getProperty(window.currentTenant, "timezone") || "America/Chicago";
moment.tz.setDefault(currentTenantTimezone);
window.moment = moment;

export const convertToTenantTimezone = (
  value,
  timezone = currentTenantTimezone
) => moment(value).tz(timezone);
export const customDateFormatWithTimezone = (
  value,
  format = CONSTANTS.DATE_FORMAT,
  timeZone = currentTenantTimezone,
  inputFormat = ""
) => moment(value, inputFormat).tz(timeZone).format(format);

export const formatDateWithTimezone = (
  value,
  timezone = currentTenantTimezone
) => moment(value).tz(timezone).format(CONSTANTS.DATE_FORMAT);

export const formatDateTimeWithTimezone = (
  value,
  timezone = currentTenantTimezone
) => moment(value).tz(timezone).format(CONSTANTS.DATE_TIME_FORMAT);

export const formatTimeWithTimezone = (
  value,
  timezone = currentTenantTimezone
) => moment(value).tz(timezone).format("h:mmA");

// The goal of this is to use an existing date with a timezone offset and change everything else
// You can pass either a date instance, or an object with time, day, month, year, etc.
export const modifyDate = (date, newDate) => {
  let newTimeDate;
  if (getProperty(newDate, "toDate")) {
    newTimeDate = moment(newDate);
    return moment(date).set({
      day: newTimeDate.day(),
      month: newTimeDate.month(),
      year: newTimeDate.year(),
      seconds: newTimeDate.seconds(),
      hours: newTimeDate.hours(),
      minutes: newTimeDate.minutes(),
      milliseconds: newTimeDate.milliseconds()
    });
  } else {
    let hours = newDate.hours;
    let minutes = newDate.minutes;
    if (newDate.time) {
      const convertedTime = moment(
        `${moment().format("MM/DD/YYYY")} ${newDate.time}`
      );
      // Note: The hours returned by moment().hours() will use the timezone offset. We have to use the date object instead.
      hours = convertedTime.toDate().getHours();
      minutes = convertedTime.toDate().getMinutes();
    }
    return moment(date).set({
      ...newDate,
      hours,
      minutes
    });
  }
};

export const kebabCase = (str) => lodashKebabCase(str || "").toLowerCase();

export const shuffleArray = (arr) => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

export const getAPIURL = () => {
  return window.location.origin;
};

export const modalHandler = () => {
  // Add default modal placeholder to body
  let container = $(".modal-content-container");
  if (!$(container).length) {
    container = $('<div class="modal-content-container"></div>');
    $("body").append(container);
  }

  // Automatically binds elements to trigger modals based on data-modal-url attrib
  $(document).on("click", "[data-modal-url]", function (e) {
    e.stopImmediatePropagation();
    const url = $(this).data("modal-url");
    $.ajax(url, {
      type: "GET",
      dataType: "script"
    });
  });

  // Handle multi-level modals
  $(document).on("show.bs.modal", ".modal", function (e) {
    e.stopImmediatePropagation();
    const openModals =
      $(".modal:visible").length + $("sera-modal[open=true]").length;
    const zIndex = 1040 + 10 * openModals;
    $(this).css("z-index", zIndex);
    return setTimeout(function () {
      return $(".modal-backdrop")
        .not(".modal-stack")
        .css("z-index", zIndex - 1)
        .addClass("modal-stack");
    }, 0);
  });
};

export const attachNotificationHelper = () => {
  let _open_toasters = [];
  const dispatchNotification = (text, type) => {
    const isSuccess = type === "success";
    const toaster = Toastify({
      text,
      className: "mt-5 alert",
      backgroundColor: isSuccess ? "#28A745" : "#DC3545",
      duration: isSuccess ? 5000 : 5 * 1000 * 60,
      escapeMarkup: false,
      close: !isSuccess
    }).showToast();

    if (_open_toasters) {
      _open_toasters.push(toaster);
      // Avoid memory leak issue by keeping only a small cache
      if (_open_toasters.length >= 5) {
        _open_toasters.shift();
      }
    }
  };
  return {
    close: function () {
      if (_open_toasters) {
        _open_toasters.forEach((toaster) =>
          toaster && toaster.hideToast ? toaster.hideToast() : ""
        );
        _open_toasters = [];
      }
    },
    success: (text) => dispatchNotification(text, "success"),
    error: (text) => dispatchNotification(text, "error")
  };
};

export const initParsley = () => {
  if ($(".parsley-validations").length) {
    $(".parsley-validations").parsley({
      excluded:
        "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden",
      successClass: "parsley-success-input"
    });
  }
};

export const initDatePicker = (selector, options) => {
  $(selector).datetimepicker({
    format: "m/d/Y",
    validateOnBlur: false,
    closeOnDateSelect: true,
    timepicker: false,
    minDate: Date.now(),
    ...options
  });
};

export const classListPolyfill = () => {
  if (window.DOMTokenList && !DOMTokenList.prototype.forEach) {
    DOMTokenList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (let i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }
};

export const isFalsy = (value) => {
  // Hanlde falsy check for undefined or null but not 0
  if (value === 0) {
    return false;
  }
  return !value;
};

export const cloneObj = (obj) => JSON.parse(JSON.stringify(obj));

export const toggleView = (elOne, elTwo) => {
  return new Promise((resolve) => {
    let fadeOut = elOne;
    let fadeIn = elTwo;
    if ($(elTwo).is(":visible")) {
      fadeOut = elTwo;
      fadeIn = elOne;
    }
    $(fadeOut).fadeOut(() => {
      $(fadeIn).fadeIn(() => resolve());
    });
  });
};

export const splitArray = (arr, dimensions = 2) => {
  if (!arr || !arr.length) {
    return arr;
  }
  const splitEvery = Math.round(arr.length / dimensions);
  const arrClone = [...arr];
  const columns = [];
  while (arrClone.length) {
    columns.push(arrClone.splice(0, splitEvery));
  }
  return columns;
};

export const generateUID = () => {
  return Math.floor(Math.random() * 1000) + Date.now();
};

export const isEmpty = (object) => {
  return Object.keys(object).length === 0;
};

export const isBlank = (string) => {
  if (string === null || string === undefined) {
    return true;
  }

  return string.trim().length === 0;
};

export const getObjDiff = (source, compare) => {
  if (!source || !compare) {
    return {};
  }
  const changed = {};
  Object.keys(source).forEach((key) => {
    if (
      Object.prototype.hasOwnProperty.call(compare, key) &&
      source[key] !== compare[key]
    ) {
      changed[key] = compare[key];
    }
  });
  return changed;
};

export const generateReqParams = (mapping, parameters) => {
  if (!mapping || !parameters) {
    return {};
  }
  return Object.keys(parameters).reduce((params, paramKey) => {
    if (Object.prototype.hasOwnProperty.call(mapping, parameters[paramKey])) {
      params[paramKey] = mapping[parameters[paramKey]];
    }
    return params;
  }, {});
};

export const getMinuteDiff = (date1, date2) => {
  // Remove seconds from both dates
  const d1 = moment(date1).format("MM/DD/YYYY h:mm a");
  const d2 = moment(date2).format("MM/DD/YYYY h:mm a");
  return moment(d1).diff(moment(d2), "minutes");
};

export const isMobileScreenSize = () => {
  return window.matchMedia("only screen and (max-width: 760px)").matches;
};

export const getElementVisibleHeight = ($el) => {
  if (!$el[0]) return "auto";
  const elH = $el.outerHeight(),
    H = $(window).height(),
    r = $el[0].getBoundingClientRect(),
    t = r.top,
    b = r.bottom;
  return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));
};

export const groupBy = (arr, key) =>
  arr.reduce((acc, curr) => {
    (acc[curr[key]] = acc[curr[key]] || []).push(curr);
    return acc;
  }, {});

export const handleStaxError = (component, error) => {
  const ERROR_SEPARATOR = "<br />\n";

  let message = error.message || error.errors?.join(ERROR_SEPARATOR) || error;
  if (typeof message === "object") {
    message = Object.keys(error)
      .map((key) => error[key])
      .join(ERROR_SEPARATOR);
  }

  const prefix = "Could not tokenize payment method: ";
  if (message.startsWith(prefix)) {
    message = message.replace(prefix, "");
  }

  // regexes for matching error messages to fields
  //   With this we will apply validation error to the field based on what Stax tells us
  //   Note that Card Number and CVV are omitted - they are Stax controlled fields and do not have
  //   Vue.js validation so unfortunately this does not apply.
  const fieldMap = {
    "routing number": "Routing Number",
    "account number": "Account Number",
    year: "Exp",
    month: "Exp"
  };

  Object.keys(fieldMap).forEach((key) => {
    if (message.match(new RegExp(key, "gi"))) {
      component.errors.add({
        field: fieldMap[key],
        msg: message
      });
    }
  });

  window.notify.error(message);

  throw new Error(message);
};

export const authenticityToken = () => {
  const meta = document.querySelector("meta[name=csrf-token]");
  if (meta) {
    return meta.getAttribute("content");
  } else {
    return "";
  }
};

export const initTippyTooltips = (selector = "[data-tippy-content]") => {
  tippy(selector, {
    onShow: () => tippy.hideAll()
  });
};
